import Joi from '@hapi/joi'

export const estateSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    operationEntityCode: Joi.string().required().invalid("00").min(2).max(2).label("Estate Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Estate Code required`,
        "string.pattern.base": `Estate Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as estate code`
    }),
    operationEntityName: Joi.string().required().label("Estate Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Estate Name required`,
        "string.pattern.base": `Please enter valid estate name`,
    }),
    operationEntityLocation: Joi.string().allow("", null).label("Estate Location"),
    isActive: Joi.boolean().label("Active")
}